import React from "react";

function TrafficHomeOne({ className }) {
  return (
    <section className={`appie-service-area pt-140 pb-180 ${className || ""}`}>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="appie-traffic-title">
              <h3 className="title">Swimming Rules and Regulations</h3>
              <h5>
                <u>Men’s Freestyle 100M | Women’s Freestyle 50M</u>
              </h5>
              <p>
                • A specific time slot will be allocated for the Swimming
                Competition. It is important to note that if any runners are not
                available due to a clash with their schedule in another game,
                they will be disqualified from the race.
              </p>
              <p>• The rules will be explained during the competition</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default TrafficHomeOne;
